import { render } from "./RepPatSummary1PatList.vue?vue&type=template&id=89d619e6"
import script from "./RepPatSummary1PatList.vue?vue&type=script&lang=js"
export * from "./RepPatSummary1PatList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__